import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import styles from "./EnterOTP.module.scss";
import { CustomButton, Header } from "../../components";
import DataSafetyMessage from "../../components/Messages/DataSafetyMessage";
import { enterotpValidation } from "../../validations/auth.validation";
import ServicesAPI from "../../services/services";
import { useNavigate } from "react-router-dom";
import { storeAccessToken, storeAttributeKey, storeCustomerID, storeLeadID, storePhoneNo, storeProductId, storeToken } from "../../utils/storage";
import { useDispatch, useSelector } from "react-redux";
import { addUserInfo, addUserName } from "../../redux/slices/userSlice";
import { fetchCredeauData } from "../../lib/credlibkit";
import { googleEvent_ONB025, googleEvent_ONB029 } from "../../lib/google-analytics";
import Cookies from "js-cookie";
import { REACT_APP_ONBOARDING_JOURNEY_URL, REACT_APP_RAMFINCORP_WEBSITE_URL } from "../../utils/environment";
import UserConsent from "../../components/userConsent";
import { redirectToOnboardingJourney } from "../../utils/utils";
import { profilePushIdentity } from "../../lib/clevertap-events";
// import ga4 from "react-ga4";

export default function EnterOTP() {
  const [seconds, setSeconds] = useState(60);
  const [otpDefaultValue, setOTPDefaultValue] = useState("");
  const [resendTrigger, setResendTrigger] = useState(0);
  const enterMobileData = useSelector((state) => state.register);

  const inputRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { mobileNumber, clickId } = enterMobileData || {};

  const { enterMobileNumber, verifyOTPAPI } = new ServicesAPI();

  useEffect(() => {
    const second = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => clearTimeout(second);
  }, [seconds]);

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current.focus();
    }, 300);

    const handleRedirect = () => {
      const token = localStorage.getItem("token");

      if (token) {
        navigate("/home");
      }
    };

    handleRedirect();

    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    if (mobileNumber) googleEvent_ONB025(mobileNumber);
  }, [mobileNumber]);

  const handleResendOTP = async () => {
    const res = await enterMobileNumber(mobileNumber);
    if (res && res.statusCode === 200) {
      setSeconds(60);
      setOTPDefaultValue("");

      setResendTrigger((prev) => prev + 1);
    }
  };

  const handleVerifyOTP = async (mobileNumber, otp, setFieldError = () => {}, consent, whatsapp_consent) => {
    try {
      const res = await verifyOTPAPI(mobileNumber, otp, consent, whatsapp_consent);

      if (res && res?.statusCode === 200) {
        const jwtToken = res.data.jwtToken;

        if (res?.data?.redirectNewUser) {
          const redirectURL = `${REACT_APP_ONBOARDING_JOURNEY_URL}`;
          // window.open(redirectURL, "_self");
          window.top.location.href = redirectURL;
          return;
        }

        if (res?.data?.redirectionToNew) {
          return redirectToOnboardingJourney(jwtToken);
        }
        const accessToken = res.data.accessToken;
        const { customerID, mobile: phoneNo, pancard, name, dob, gender, email } = res?.data?.customer || {};
        if (window.clarity) {
          window.clarity("identify", customerID);
          window.clarity("set", {
            customerID,
          });
        }
        storeToken(jwtToken);
        storeAccessToken(accessToken);
        storeCustomerID(customerID);
        storePhoneNo(phoneNo);
        localStorage.setItem("customerType", res?.data?.lead?.customer_type);
        localStorage.setItem("pancard", pancard);
        localStorage.setItem("email", email);
        storeProductId(res?.data?.lead?.productId);
        storeLeadID(res?.data?.lead?.leadID);
        storeAttributeKey(res?.data?.attributeKey);

        dispatch(addUserName(name));
        dispatch(addUserInfo(res?.data?.customer));

        // Cookies
        Cookies.set("customerID", customerID, { expires: 7 });

        profilePushIdentity({ customerID, mobile: phoneNo, dob, gender, name, email });

        if (clickId) {
          window.localStorage.removeItem("clickId");
          window.localStorage.setItem("clickId", clickId);
        }

        // Credeau SDK
        fetchCredeauData(res?.data?.customer?.customerID);
        localStorage.setItem("custId", res?.data?.customer?.customerID);

        setTimeout(() => {
          googleEvent_ONB029();
          if (res?.data?.journey) {
            if (window.parent) {
              window.parent.location.href = `${res.data.journey}`;
            } else {
              window.location.href = `${res.data.journey}`;
            }
          } else {
            navigate("/home");
          }
        }, 100);
      } else {
        setFieldError("otp", res?.message || "Something went wrong");
      }

      setOTPDefaultValue(null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if ("OTPCredential" in window && mobileNumber) {
      const ac = new AbortController();
      navigator.credentials
        .get({ otp: { transport: ["sms"] }, signal: ac.signal })
        .then(async (otp) => {
          if (otp?.code) {
            // console.log("OTP received:", otp);

            handleVerifyOTP(mobileNumber, otp.code);

            setOTPDefaultValue(otp.code);
          }
        })
        .catch((err) => console.error("OTP autofill failed:", err));

      return () => ac.abort();
    }
  }, [mobileNumber, resendTrigger]);

  return (
    <div className={`wrapper ${styles.home}`}>
      <Formik
        initialValues={{ otp: "" }}
        validationSchema={enterotpValidation}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          setSubmitting(true);

          setTimeout(async () => {
            await handleVerifyOTP(mobileNumber, values.otp, setFieldError, true, true);

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldError }) => (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <div className="vertical-column-layout">
              <div className="vertical-column-top">
                <Header />

                <div className="mb-2">
                  <p className={styles.label}>Enter OTP</p>
                  <p className={styles.sub__label}>Please enter the OTP</p>
                </div>

                <div className={styles.content}>
                  <input
                    type="tel"
                    className={styles.form__input}
                    placeholder=""
                    name="otp"
                    value={values.otp || otpDefaultValue}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input !== "000000000000" && /^\d*$/.test(input)) {
                        setFieldValue("otp", e.target.value);

                        // if (input.length === 4) {
                        //   handleVerifyOTP(mobileNumber, input, setFieldError);
                        // }
                      }
                    }}
                    onBlur={(e) => {
                      setFieldValue("otp", e.target.value.trim());
                    }}
                    autoComplete="off"
                    maxLength={4}
                    ref={inputRef}
                  />

                  {touched.otp && errors.otp ? <div className="error-msg">{errors.otp}</div> : null}

                  <p className={styles.sub__label} style={{ marginTop: 10 }}>
                    We've sent a 4-digit verification code to your <br /> mobile number <span className={styles.mobile__number}>+91 {mobileNumber}</span> <br />{" "}
                    <span className={styles.change__number} onClick={() => navigate("/")}>
                      Change mobile number
                    </span>
                  </p>
                  <p className={styles.sub__label}>
                    Have not received your OTP?{" "}
                    <span
                      className={styles.resend}
                      onClick={() => {
                        if (seconds === 0) {
                          handleResendOTP();
                        }
                      }}
                    >
                      Resend
                    </span>{" "}
                    {seconds > 0 && <span>in {seconds} seconds</span>}
                  </p>
                </div>
              </div>

              <div
                className="vertical-column-bottom"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <UserConsent
                  checked={true}
                  name="consent"
                  text={
                    <>
                      By proceeding, you agree to our{" "}
                      <a target="_parent _blank" href={`${REACT_APP_RAMFINCORP_WEBSITE_URL}/personal-loan-terms-conditions`}>
                        Terms&nbsp;&&nbsp;Conditions
                      </a>{" "}
                      and{" "}
                      <a target="_parent _blank" href={`${REACT_APP_RAMFINCORP_WEBSITE_URL}/privacypolicy`}>
                        Privacy Policy
                      </a>
                      , and consent to us accessing your credit information from credit bureaus for processing your application.
                    </>
                  }
                />
                <UserConsent
                  checked={true}
                  name="whatsapp_consent"
                  text={
                    <>
                      I consent to receive <strong>loan-related updates, alerts, and communications via WhatsApp</strong> on my registered mobile number.
                    </>
                  }
                />
                <DataSafetyMessage />
                <CustomButton text="Verify" type="submit" floating={false} />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}
